import { UpOutlined } from "@ant-design/icons";
import { Dropdown, Tooltip } from "antd";
import { bg_button, bg_text } from "constant/css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
const CustomDropdown = () => {
  const navigate = useNavigate();

  const menuItems = (
    <div className="py-1">
      <button
        onClick={() => navigate("/admin")}
        className="block hover:-translate-y-1 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition duration-200"
      >
        Админ
      </button>
      <button
        onClick={() => navigate("/merchant")}
        className="block hover:-translate-y-1 w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition duration-200"
      >
        Мерчант
      </button>
    </div>
  );

  return (
    <Dropdown
      overlay={menuItems}
      placement="bottomRight"
      trigger={["hover"]}
      overlayClassName="rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
    >
      <button
        className={`hover:-translate-y-1 text-[#fff] ${bg_button} px-4 py-2 rounded-md shadow-md hover:text-white transition-all duration-300`}
      >
        Нэвтрэх
      </button>
    </Dropdown>
  );
};
const CustomTooltip = styled(Tooltip)`
  .ant-popover-inner {
    background-color: #2ea5a1; /* Primary color */
    color: #fff; /* Text color */
  }
  .ant-popover-title {
    background-color: #2ea5a1; /* Primary color */
  }
  .ant-tooltip-placement-bottom {
    margin-top: 8px; /* Adjust the margin for bottom placement */
  }
  .ant-tooltip-placement-top {
    margin-bottom: 8px; /* Adjust the margin for top placement */
  }
`;
const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button on scroll
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return isVisible ? (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-2 left-1/2 ${bg_button} transform -translate-x-1/2 px-6 py-2 bg-gray-100 text-black rounded-t-full shadow-lg flex items-center gap-2 hover:bg-gray-200 transition-all duration-300 z-50`}
    >
      <span className="text-white font-extrabold	">^</span>
    </button>
  ) : null;
};

export default function Home() {
  const navigate = useNavigate();
  const [active, setActive] = useState("xBilling");
  const serviceData = {
    xBilling: {
      key: "xBilling",
      name: "Smart Billing",
      title: "Бүх төрлийн нэхэмжлэх үүсгэж, төлүүлэх ухаалаг шийдэл",
      shortDescription: "Билл үүсгэх, төлүүлэх ажлыг тань хялбарчилна",
      description:
        "Смарт Биллинг нь тогтмол, их хэмжээгээр үүсдэг үйлчилгээний нэхэмжлэхүүдээ удирдахад тань туслана. Та мянга, мянган үнэнч хэрэглэгчдийнхээ төлбөрийг хялбархан удирдаж, орлогоо хурдан, найдвартай хүлээн авах боломжтой.",
      features: [
        "Бүртгүүлээд биллинг үүсгэх тохиргоогоо хийнэ",
        "Хэрэглэгчээ бүртгэн, нэхэмжлэхийг нь илгээнэ",
        "Хэрэглэгч тань нэхэмжлэхээ төлөхөд бэлэн",
      ],
      cta: "Дэлгэрэнгүй",
      img: "/smartbilling.png",
      whyExplains: [
        {
          title: "Хэрэглэгчийн бүртгэл хийх, хэрэглэгчээ таних",
          description:
            "Смарт биллинг ашигласнаар та хэрэглэгч тус бүрийн нэхэмжлэхийн статусыг харахаас гадна өмнөх төлбөрийн түүхийг бүрэн хянана.",
        },
        {
          title: "Нэхэмжлэхээ хүссэнээрээ үүсгэнэ",
          description:
            "Та үзүүлж буй үйлчилгээнийхээ онцлогоос хамааран тогтмол дүнгээр, томъёогоор гэх мэтчилэн өөрийн хүссэн хэлбэрээр нэхэмжлэх үүсгэх боломжтой.",
        },
        {
          title: "Үйлчилгээнийхээ үр дүнг нэгтгэн харах",
          description:
            "Ямар төрлийн үйлчилгээг хэрэглэгч илүү авч байгаа, ямар төлбөрийн хэрэгслийг илүү ашиглаж байгаа гэх мэтээр орлогод үндэслэсэн үр дүнгийн хяналт хийх боломжтой.",
        },
        {
          title: "Хэрэглэгчидтэйгээ харилцах",
          description:
            "Зөвхөн төлбөр тооцоо бус үйлчилгээ, төлбөртэй холбоотой хэрэглэгчийн хүсэлтийг хүлээн авч, шийдвэрлэх, хариу өгөх боломжтой.",
        },
        {
          title: "НӨАТ-н бүртгэл хийх",
          description:
            "Смарт биллинг нь НӨАТ-н иБаримт системтэй холбогдон ажилладаг. Таны хэрэглэгч хувь хүн, байгууллагаас үл хамааран НӨАТ-н баримтаа хүссэнээрээ авах боломжтой.",
        },
        {
          title: "Төлбөрийн хэрэгслүүдтэй холбогдох",
          description:
            "Смарт биллинг нь qPay, Negdi операторуудаар дамжуулан Монгол Улсад үйл ажиллагаа явуулж буй бүх төлбөрийн хэрэгслүүдтэй холбогдон ажилладаг.",
        },
      ],
      prices: [
        {
          name: "Бие даасан шийдэл",
          price: "₮2,200",
          description: "Нэг нэхэмжлэхийн сарын төлбөр",
          features: ["Дангаараа ажиллах"],
          cta: "Багц идэвхжүүлэх",
          disabled: false,
        },
        {
          name: "Хэрэглэгчийн системтэй уялдсан шийдэл",
          price: "₮5,500",
          description: "Нэг нэхэмжлэхийн сарын төлбөр",
          features: [
            "Хэрэглэгчийн өөрийн ашигладаг системтэй уялдуулан ажиллуулах",
          ],
          cta: "Багц идэвхжүүлэх",
          disabled: false,
        },
        {
          name: "Байгууллагын шийдэл",
          price: "Тохиролцоно",
          description: "Орлогын хувь",
          features: ["Бүх төлбөрийн хэлбэр", "API & webhook", "Хялбар бүртгэл"],
          cta: "Багц идэвхжүүлэх",
          disabled: true,
        },
      ],
    },

    xPay: {
      key: "xPay",
      name: "Smart Pay",
      title: "Төлбөрийн хэрэгслүүдийн нэгдсэн шийдэл!",
      shortDescription: "Төлбөр хүлээн авах нэгдсэн шийдэл",
      description:
        "Таньд банкны апп, карт болон зээлийн апп-уудтай холбогдсон нэгдсэн шийдэл хэрэгтэй байна уу? Төлбөрийн баримтыг НӨАТ-н системд хувь хүн, байгууллагаар ялган бүртгэх хэрэгтэй байна уу? Танай борлуулалтын системд QR ашиглан төлбөрөө хүлээн авах шийдэл хэрэгтэй байна уу? Эдгээр асуултанд нэгэн зэрэг хариулах хариулт нь Смарт Пэй юм",
      features: [
        "Бүртгүүлээд мерчант эрхээ үүсгэ",
        "xPay-ийн API-г ашиглан үйлчилгээгээ холбо",
        "Орлогоо шууд дансандаа аваад эхлэ",
      ],
      cta: "7 хоног турших",
      img: "/smartpay.png",
      whyExplains: [
        {
          title: "Бүх төлбөрийн хэрэгслүүдтэй холбогдсон",
          description:
            "Смарт пэй нь данс, карт, бусад цахим хэтэвчүүд ашиглан төлбөр хүлээн авах боломжтой. Та тэр олон газруудтай уулзах цагаа хэмнээрэй",
        },
        {
          title: "Хялбар API",
          description:
            "Та өөрийн ашиглаж буй программыг Смарт пэй-н API-тай холбож, интеграцчилах замаар, төлбөрийн процессоо автоматжуулах боломжтой.",
        },
        {
          title: "Hosted Checkout & Invoice",
          description:
            "Смарт пэй нь таны төлбөрийн процессийг хялбарчилж, танай хэрэглэгчид QR уншуулан шаардлагатай мэдээллийг бөглөх замаар төлбөр төлөх боломжийг олгоно.",
        },
        {
          title: "Realtime Webhook",
          description:
            "xPay нь Real-time Webhook дэмждэг. Энэ нь таны програмд шууд мэдэгдэл илгээж, төлбөрийн статусыг хянахад тусална.",
        },
        {
          title: "Админ панел",
          description:
            "Манай админ панел нь таны бизнесийн орлогыг хянахад тусална. Та орлого, зардал, хэрэглэгчдийн мэдээллийг хялбархан удирдах боломжтой.",
        },
      ],
      prices: [
        {
          name: "Эхлэл багц",
          price: "Сарын ₮99,000",
          description: "Бизнесээ эхлүүлж буй хэн бүхэнд зориулсан",
          features: [
            "Сарын 10 сая хүртэл борлуулалттай бизнес эрхлэгдчдэд зориулав",
          ],
          cta: "Багц идэвхжүүлэх",
          disabled: false,
        },
        {
          name: "Өсөлт багц",
          price: "Орлогын 2.4 хувь",
          description: "Жижиг, дунд бизнес эрхлэгчдэд зориулсан",
          features: [
            "Сарын 10-с 200 сая хүртэл борлуулалттай бизнес эрхлэгчдэд зориулав",
          ],
          cta: "Багц идэвхжүүлэх",
          disabled: false,
        },
        {
          name: "Байгууллагын багц",
          price: "Холбоо барих",
          description: "Том бизнес эрхлэгчдэд зориулсан",
          features: ["Байгууллагын хэрэгцээ шаардлагад нийцүүлэн тохирно"],
          cta: "Багц идэвхжүүлэх",
          disabled: true,
        },
      ],
    },
  };
  const signUp = () => {
    navigate("/signUp");
  };
  return (
    <div
      className={`bg-gradient-to-b from-white to-gray-50 min-h-screen font-sans text-gray-800`}
    >
      {/* Header */}
      <header className="flex items-center justify-between p-6 max-w-7xl mx-auto">
        <div className="relative max-w-xl h-[100px] w-[100px] mx-auto md:mx-0 rounded-3xl overflow-hidden">
          {/* Simple image slider with preloading for smoother fade */}
          <img
            key={1}
            src={serviceData[active].img}
            alt={`xPay feature ${1 + 1}`}
            // Using z-index to ensure the new image appears on top during fade
            className={`absolute inset-0 w-full h-full object-cover transition-opacity shadow-2xl duration-1000 ease-in-out opacity-100 z-10`}
          />
          <span className="text-md text-black">Smart Billing LLC</span>
        </div>

        {/* Changed to primary color */}
        <div className="space-x-6 hidden md:flex items-center">
          <a
            href="#why_us"
            className="text-sm hover:text-primary transition-colors"
          >
            Ямар үйлчилгээ вэ?
          </a>
          <a
            href="#price"
            className="text-sm hover:text-primary transition-colors"
          >
            Үнийн санал
          </a>
          <a
            href="#faq"
            className="text-sm hover:text-primary transition-colors"
          >
            FAQ
          </a>

          {/* Replaced Ant Design Dropdown with Tailwind CSS */}
          <CustomDropdown />
          <button
            onClick={signUp}
            className={`hover:-translate-y-1 ${bg_button} text-white shadow-green-300/50 px-4 py-2 rounded-md shadow-md  hover:bg-[#46ce7c] transition-colors`}
          >
            {" "}
            {/* Changed to primary color */}
            Бүртгүүлэх
          </button>
        </div>
      </header>
      <section
        id=""
        className="relative flex w-full overflow-hidden mt-10 items-center justify-center bg-gradient-to-br from-white to-primary/10"
      >
        <div className="flex justify-center my-2">
          <div className="relative flex bg-gray-100 p-1 rounded-full shadow-md">
            {/* Animated Background Indicator */}
            <div
              className={`absolute h-[40px] w-[135px] rounded-full ${bg_button} transition-all duration-300 ease-in-out z-0`}
              style={{
                transform: `translateX(${
                  Object.keys(serviceData).indexOf(active) * 135
                }px)`,
              }}
            ></div>

            {Object.keys(serviceData).map((key) => {
              const isActive = active === serviceData[key].key;
              return (
                <CustomTooltip
                  title={serviceData[key].shortDescription}
                  key={serviceData[key].name}
                  placement="bottom"
                >
                  <button
                    onClick={() => setActive(serviceData[key].key)}
                    className={`relative z-10 px-4 py-2 text-sm w-[135px] h-[40px] font-semibold rounded-full transition-all duration-300 ${
                      isActive ? "text-white" : "text-gray-500"
                    }`}
                  >
                    {serviceData[key].name}
                  </button>
                </CustomTooltip>
              );
            })}
          </div>
        </div>
      </section>

      {/* Hero */}
      <section className="relative overflow-hidden py-12 md:py-12 bg-gradient-to-br from-white to-primary/10">
        {" "}
        {/* Added a subtle gradient background */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side: Text Content and CTA */}
          <div className="text-center md:text-left animate-fade-in-up">
            {" "}
            {/* Added a simple animation class */}
            <h2
              className={`text-4xl md:text-5xl lg:text-4xl ${bg_text} text-transparent font-extrabold mb-6 leading-tight text-gray-900`}
            >
              {serviceData[active].title}
            </h2>
            <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-lg md:mx-0 mx-auto">
              {serviceData[active].description}
            </p>
            <ul className="mb-10 text-base md:text-lg text-left max-w-md mx-auto md:mx-0 space-y-3">
              {serviceData[active].features.map((feature, index) => (
                <li className="flex items-center">
                  <span className="text-primary font-medium mr-2 text-xl">
                    ✓
                  </span>{" "}
                  {feature}
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <button className="bg-[#64B9A7] text-[#fff] px-6 py-3 rounded-xl shadow-primary-lg transition-all duration-300 transform hover:-translate-y-1 text-md font-semibold">
                7 хоног турших
              </button>
              <button className="bg-[#449BB0] text-white border border-primary px-6 py-3 rounded-xl shadow-md hover:bg-primary/10 transition-all duration-300 transform hover:-translate-y-1 text-md font-semibold">
                Дэлгэрэнгүй
              </button>
            </div>
          </div>

          {/* Right Side: Image Slider/Visuals */}
          <div className="relative h-96 w-full items-center justify-center flex max-w-xl mx-auto md:mx-0 rounded-3xl overflow-hidden">
            {/* Simple image slider with preloading for smoother fade */}
            <img
              src={serviceData[active].img}
              alt={`xPay feature ${1 + 1}`}
              // Using z-index to ensure the new image appears on top during fade
              className={`absolute inset-0 w-full h-full object-cover transition-opacity shadow-2xl duration-1000 ease-in-out opacity-100 z-10`}
            />
          </div>
        </div>
      </section>
      {/* Features */}
      <section id="why_us" className="py-16 bg-white">
        <h3 className="text-3xl font-bold text-center mb-12">
          Яагаад {serviceData[active].name} гэж?
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto px-4">
          {serviceData[active].whyExplains.map((e, index) => (
            <div
              key={index}
              className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
            >
              <h4 className="font-semibold text-lg mb-2">{e.title}</h4>
              <p className="text-sm text-gray-500">{e.description}</p>
            </div>
          ))}
        </div>
      </section>
      {/* Testimonial */}
      <section className="bg-gray-100 py-16 text-center">
        <p className="text-xl max-w-2xl mx-auto italic mb-6">
          "Смарт Биллинг нь манай бизнесийн төлбөр хүлээн авах процессыг
          хялбарчилж, хэрэглэгчдэд илүү сайн туршлага санал болгосон. Бид маш
          сэтгэл хангалуун байна!"
        </p>
        <p className="font-semibold text-gray-700">
          З.Цолмонбаяр- Үүсгэн байгуулагч
        </p>
      </section>
      {/* Pricing */}
      <section id="price" className="py-16 bg-white">
        <h3 className="text-3xl font-bold text-center mb-8">Үнийн санал</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto px-4">
          {serviceData[active].prices.map((plan, i) => (
            <div
              key={plan}
              className="border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-xl transition-shadow duration-300"
            >
              <h4 className="text-xl font-semibold mb-2">
                {plan.name}{" "}
                <span className="text-sm">({plan.description})</span>
              </h4>
              <p className="text-gray-600 mb-4 text-2xl font-bold">
                {plan.price ? plan.price : "Холбоо барих"}
              </p>
              <ul className="text-sm text-gray-600 space-y-2 mb-6">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-center">
                    <span className="text-primary font-medium mr-2 text-lg">
                      ✓
                    </span>
                    {feature}
                  </li>
                ))}
              </ul>
              <button
                className={`bg-primary w-full px-4 py-2 ${bg_button} rounded-md shadow-md bg-[#46ce7c] text-white transition-colors`}
              >
                {" "}
                {/* Changed to primary color */}
                Багц идэвхжүүлэх
              </button>
            </div>
          ))}
        </div>
      </section>
      {/* FAQ */}
      <section id="faq" className="bg-gray-50 py-16 px-4">
        <h3 className="text-2xl font-bold text-center mb-6">
          Түгээмэл асуулт хариулт
        </h3>
        <div className="max-w-2xl mx-auto space-y-4">
          {[
            "xPay гэж юу хийдэг вэ?",
            "Ямар төлбөрийн хэлбэрүүдийг дэмждэг вэ?",
            "Техникийн дэмжлэгтэй юу?",
          ].map((q, i) => (
            <details
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm"
            >
              <summary className="cursor-pointer font-semibold text-gray-800 flex justify-between items-center">
                {q}
                <span className="ml-2">
                  <svg
                    className="w-4 h-4 text-gray-500 transform transition-transform duration-200 group-open:rotate-180"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </span>
              </summary>
              <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                Энд тайлбар мэдээлэл бичнэ.
              </p>
            </details>
          ))}
        </div>
      </section>
      {/* Footer */}
      <footer className="text-center py-8 text-sm text-gray-500 bg-white border-t border-gray-100">
        <p>© 2025 SmartBilling LLC - Бүх эрх хуулиар хамгаалагдсан</p>
      </footer>
      <ScrollToTopButton />
    </div>
  );
}
